<template>
  <div class="file-upload-area" :class="{ error: hasError }">
    <input
      :id="id"
      type="file"
      class="file-upload-area__input"
      accept="image/*"
      @change="onFileChange"
    />
    <label :for="id" class="file-upload-area__label">
      <span class="file-upload-area__label--icon"></span>
      <div class="file-upload-area__label--text">
        {{ label }}
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onFileChange(e) {
      this.$emit('change-file', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.file-upload-area {
  font-size: 1.6rem;
  line-height: 1.6;
  cursor: pointer;
  text-decoration: none;
  color: $link;
  background-color: $gray-3;
  border-radius: 8px;
  width: 100%;

  @media (hover: hover) {
    &:hover {
      opacity: 0.7;
    }
  }

  &__input {
    display: none;
  }

  &__label {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    &--icon {
      background-image: url('../../../../../images/icons/link-camera.svg');
      background-repeat: no-repeat;
      background-color: $gray-3;
      object-fit: contain;
      width: 20px;
      height: 20px;
    }

    &--text {
      padding: 32px 0;
    }
  }
}
.error {
  border: 1px solid $danger;
  border-radius: 8px;
}
</style>
